// eslint-disable-next-line import/no-anonymous-default-export
export default /* glsl */`

// assign variables of the base UV map for different maps
// note that the transforms are complete transformation matrices

#ifdef USE_MAP
	mapUv = ( uvTransform * vec3( uv, 1 ) ).xy;
#endif

#ifdef USE_BUMPMAP
	bumpMapUv = ( bumpMapUvTransform * vec3( uv, 1 ) ).xy;
#endif

#ifdef USE_NORMALMAP
	normalMapUv = ( normalMapUvTransform * vec3( uv, 1 ) ).xy;
#endif

#ifdef USE_ALPHAMAP
	if (uv2AlphaMap){
		alphaMapUv = ( alphaMapUvTransform * vec3( uv2, 1 ) ).xy;
	} else {
		alphaMapUv = ( alphaMapUvTransform * vec3( uv, 1 ) ).xy;
	}
#endif

#ifdef USE_EMISSIVEMAP
	emissiveMapUv = ( emissiveMapUvTransform * vec3( uv, 1 ) ).xy;
#endif

#ifdef USE_ROUGHNESSMAP
	roughnessMapUv = ( roughnessMapUvTransform * vec3( uv, 1 ) ).xy;
#endif

#ifdef USE_METALNESSMAP
	metalnessMapUv = ( metalnessMapUvTransform * vec3( uv, 1 ) ).xy;
#endif

#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )
	vUv2 = uv2;
#endif

`;